import * as mammoth from 'mammoth';
import { encode } from 'gpt-tokenizer';

export const docxToTokenCount = async (file: File): Promise<number> => {
  const arrayBuffer = await file.arrayBuffer();
  const { value } = await mammoth.extractRawText({ arrayBuffer });
  return encode(value ?? '').length;
};
